var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pencil--Streamline-Core.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3503 1.91821L11.3503 1.91823L11.354 1.91444C11.4133 1.85379 11.4841 1.80561 11.5623 1.77271C11.6405 1.73982 11.7244 1.72287 11.8092 1.72287C11.894 1.72287 11.978 1.73982 12.0562 1.77271C12.1343 1.80561 12.2052 1.85379 12.2645 1.91444L12.2644 1.91445L12.2668 1.91676L14.082 3.74228L14.082 3.74229L14.0839 3.74418C14.1436 3.80337 14.191 3.87379 14.2233 3.95137C14.2556 4.02896 14.2722 4.11218 14.2722 4.19623C14.2722 4.28028 14.2556 4.3635 14.2233 4.44108L14.5823 4.59064L14.2233 4.44108C14.191 4.51867 14.1436 4.58909 14.0839 4.64827L14.0821 4.65007L5.74464 13.0282L1.8939 14.1064L2.97211 10.2557L11.3503 1.91821Z",
    stroke: "#024776",
    strokeWidth: 0.777778
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.94808 13.3751L1.33301 14.6673L2.62523 10.0522L11.0759 1.64255C11.1715 1.54487 11.2855 1.46726 11.4114 1.41427C11.5374 1.36128 11.6726 1.33398 11.8092 1.33398C11.9458 1.33398 12.0811 1.36128 12.207 1.41427C12.3329 1.46726 12.447 1.54487 12.5425 1.64255L14.3578 3.46807C14.4539 3.56341 14.5302 3.67684 14.5823 3.80182C14.6343 3.92679 14.6611 4.06084 14.6611 4.19623C14.6611 4.33162 14.6343 4.46566 14.5823 4.59064C14.5302 4.71561 14.4539 4.82904 14.3578 4.92438L5.94808 13.3751Z",
    stroke: "#024776",
    strokeWidth: 0.777778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.9420b66af850936d7cf102651d1d1ec1.svg";
export { ForwardRef as ReactComponent };